function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 22,
  height: 29
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8956 0C16.8758 0 21.7911 4.83337 21.7911 10.8956C21.6273 16.8758 14.9916 24.9861 10.8956 28.9183C6.79949 25.3138 0.163843 16.6301 0 10.8956C0 4.83337 4.83337 0 10.8956 0Z",
  fill: "#113CBE"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: -11,
  y: -11,
  width: 43,
  height: 43
}, /*#__PURE__*/React.createElement("rect", {
  x: -10.5825,
  y: -10.3574,
  width: 42.3302,
  height: 42.3302,
  fill: "#C4C4C4"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -18.8638,
  y: -11.9952,
  width: 44.6277,
  height: 44.6277,
  fill: "#2F7CEE"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.7167,
  cy: 10.3186,
  r: 22.3138,
  fill: "#D2E0DD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.7167 -11.9952C13.3931 -11.9952 3.40283 -2.00496 3.40283 10.3186C3.40283 16.3001 5.75636 21.7319 9.5879 25.7385L41.1793 -5.76907C37.1687 -9.62485 31.7195 -11.9952 25.7167 -11.9952Z",
  fill: "#126131"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -8.15842,
  cy: -4.33533,
  r: 14.7014,
  fill: "#B42813"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -6.87377,
  cy: 22.1654,
  r: 15.8909,
  fill: "#113CBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-14.1059 49.57L54.5008 -19.0368H40.6082L-27.9509 49.57H-14.1059Z",
  fill: "#FC613B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-32.3276 3.70535H62.304V10.3662H-32.3276V3.70535Z",
  fill: "#EA8A85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.9364 3.70535H63.0652L13.2991 53.519H-2.8772L46.9364 3.70535Z",
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-41.8911 47.9048L33.0434 -27.0298H40.8937L-34.0408 47.9048H-41.8911Z",
  fill: "#E0B499"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask2",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: -12,
  width: 46,
  height: 45
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25.7167,
  cy: 10.3186,
  r: 22.3138,
  fill: "#D2E0DD"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-14.1061 49.57L54.5006 -19.0368H40.608L-27.9512 49.57H-14.1061Z",
  fill: "#F8121F"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-17.436 70.6469L57.4985 -4.28769H60.591L-14.3435 70.6469H-17.436Z",
  fill: "#0E3BC0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0504 10.4138L31.7112 3.75293H17.9138L11.2529 10.4138H25.0504Z",
  fill: "#A0E6D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.59336 10.3662L10.2542 3.70535H2.26119L-4.39966 10.3662H3.59336Z",
  fill: "#E1755A"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.4374 25.0444C63.7531 22.4799 62.3836 19.0425 62.3836 14.732V14.5137C62.3836 10.1487 63.7531 6.65668 66.4374 3.98309C69.1764 1.30951 72.6276 0 76.8458 0C80.8448 0 84.1316 1.30951 86.6515 3.98309C89.2262 6.65668 90.4862 9.93045 90.4862 13.859C90.4862 14.6774 90.4314 15.4413 90.3766 16.1506H68.9025C69.1216 20.5157 72.3537 23.3529 77.2292 23.3529C80.0778 23.3529 82.543 22.3162 84.6794 20.1883L88.6236 24.0077C85.5011 27.2815 81.6665 28.9184 77.0101 28.9184C72.6824 28.9184 69.1216 27.6088 66.4374 25.0444ZM71.532 7.31143C70.0529 8.45725 69.2312 9.87589 69.0669 11.5673H83.8029C83.8029 9.93045 83.0908 8.51182 81.7212 7.36599C80.3517 6.16561 78.7631 5.56542 76.8458 5.56542C74.8189 5.56542 73.0111 6.16561 71.532 7.31143ZM117.137 4.31064C119.822 1.52794 123.108 0.16386 126.998 0.16386C131.545 0.16386 134.886 2.07356 135.818 4.74715V0.764054H138.244C140.534 0.764054 142.391 2.62087 142.391 4.91137V28.2638H139.801C137.601 28.2638 135.818 26.4805 135.818 24.2807C134.886 26.9543 131.545 28.864 126.998 28.864C123.108 28.864 119.822 27.4999 117.137 24.7717C114.508 21.989 113.193 18.6061 113.193 14.5139C113.193 10.4217 114.508 7.03879 117.137 4.31064ZM121.37 20.5158C122.959 22.0982 124.876 22.9166 127.232 22.9166C129.587 22.9166 131.614 22.0982 133.203 20.5158C134.846 18.9335 135.668 16.9147 135.668 14.5139C135.668 12.1131 134.846 10.0943 133.203 8.51199C131.614 6.92966 129.587 6.11122 127.232 6.11122C124.876 6.11122 122.959 6.92966 121.37 8.51199C119.836 10.0943 119.069 12.1131 119.069 14.5139C119.069 16.9147 119.836 18.9335 121.37 20.5158ZM101.127 28.2638V15.4112C101.127 11.5675 104.155 6.4386 108.578 6.4386C109.564 6.4386 110.495 6.54772 111.317 6.71141V0.382113C110.769 0.272988 109.345 0.218425 109.345 0.218425C105.761 0.218425 102.442 1.32181 101.127 4.21364V0.764054H94.6085V28.2638H101.127ZM49.2244 28.2638L61.0571 0.764054H57.0287C55.3546 0.764054 53.8447 1.77046 53.2006 3.31561L46.4854 19.4246L39.7188 3.30605C39.0723 1.766 37.5651 0.764054 35.8948 0.764054H31.8589L33.338 4.20152L34.8171 7.63898L37.7752 14.5139L43.6916 28.2638H49.2244Z",
  fill: "#113CBE"
});

var SvgVera = function SvgVera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 29,
    viewBox: "0 0 143 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vera.50c4179b.svg";
export { ForwardRef as ReactComponent };